import { Component } from 'vue-facing-decorator';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Alternatives/AlternativesViews/Domain/commands-core';

@Component
export default class AlternativesViewsCommands extends VueCqrs
{
	invokeCreateStaticViewCommandV1(workspaceId: number, id: string, alternativesListId: number, alternativesIds: number[], name: string)
	{
		const cmd = new c.CreateStaticViewCommandV1(workspaceId, id, alternativesListId, alternativesIds, name);
		this.$command(cmd, id);
	}

	invokeUpdateStaticViewCommandV1(workspaceId: number, projectId: number, alternativesListId: number, id: string, name: string, alternativesIds: number[])
	{
		const cmd = new c.UpdateStaticViewCommandV1(workspaceId, projectId, alternativesListId, id, name, alternativesIds);
		this.$command(cmd, id);
	}

	invokeAddAlternativesToStaticViewCommandV1(workspaceId: number, id: string, alternativesListId: number, alternativesIds: number[])
	{
		const cmd = new c.AddAlternativesToStaticViewCommandV1(workspaceId, id, alternativesListId, alternativesIds);
		this.$command(cmd);
	}

	invokeRemoveAlternativesFromStaticViewCommandV1(workspaceId: number, id: string, alternativesListId: number, alternativesIds: number[])
	{
		const cmd = new c.RemoveAlternativesFromStaticViewCommandV1(workspaceId, id, alternativesListId, alternativesIds);
		this.$command(cmd);
	}


	invokeCreateDynamicViewCommandV1(workspaceId: number, projectId: number, alternativesListId: number, id: string, name: string, filterData: string)
	{
		const cmd = new c.CreateDynamicViewCommandV1(workspaceId, projectId, alternativesListId, id, name, filterData);
		this.$command(cmd, id);
	}

	invokeUpdateDynamicViewCommandV1(workspaceId: number, projectId: number, alternativesListId: number, id: string, name: string, filterData: string)
	{
		const cmd = new c.UpdateDynamicViewCommandV1(workspaceId, projectId, alternativesListId, id, name, filterData);
		this.$command(cmd, id);
	}


	invokeDeleteAlternativesViewCommandV1(workspaceId: number, projectId: number, alternativesListId: number, viewDefId: string)
	{
		const cmd = new c.DeleteAlternativesViewCommandV1(workspaceId, projectId, alternativesListId, viewDefId);
		this.$command(cmd, viewDefId);
	}
}
